<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<p class="CT ParaOverride-11" id="_idParaDest-6"><span class="CharOverride-15">From time to time, God causes men to be born—and thou art one of them—who have a lust to go abroad at the risk of their lives and discover news—today it may be of far-off things, tomorrow of some hidden mountain, and the next day of some nearby men who have done a foolishness against the state. These souls are very few; and of these few, not more than ten are of the best.</span></p>
<p class="BT1stPara ParaOverride-12"><span class="CharOverride-16">—Kim, </span><span class="CharOverride-17">Rudyard Kipling</span></p>
<p class="CAP ParaOverride-13"><span class="CharOverride-18"><img alt="" class="_idGenObjectAttribute-2" src="image/C01.jpg"/></span></p>
<p class="CAP"><span class="CharOverride-18">“That Africa is now but a memory . . .”</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// eBook_V28915.vue?1cbdd3b8